<template>
  <IconWrapper :dense="dense">
    <svg :class="{ disable }" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.09004 6.96754L9.00004 9.87754L11.91 6.96754C12.2025 6.67504 12.675 6.67504 12.9675 6.96754C13.26 7.26004 13.26 7.73254 12.9675 8.02504L9.52504 11.4675C9.23254 11.76 8.76004 11.76 8.46754 11.4675L5.02504 8.02504C4.73254 7.73254 4.73254 7.26004 5.02504 6.96754C5.31754 6.68254 5.79754 6.67504 6.09004 6.96754Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  inheritAttrs: false,

  props: {
    dense: Boolean,
    disable: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg {
  > path {
    fill: var(--r-secondary-1);
  }

  &.disable > path {
    fill: var(--r-white-5);
  }
}
</style>
